import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const SalaryView = ({ currentItem, handleView }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[850px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">View Salary</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => handleView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Employee ID:</strong>
                      <h6>{currentItem.Employee?.employeeId || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Employee name:</strong>
                      <h6>{currentItem.Employee.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Job Title:</strong>
                      <h6>{currentItem.Job?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Department name:</strong>
                      <h6>{currentItem.Department?.name || ""}</h6>
                    </div>
                  </div>
                  {/* <div className='sm:py-4 sm:px-2 py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <strong>Description:</strong>
                      <h6>{currentItem.description.join(', ') || ''}</h6>
                    </div>
                  </div> */}
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Email ID:</strong>
                      <h6>{currentItem.Employee?.email || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Joining Date:</strong>
                      <h6>{dayjs(currentItem.JobRequests?.acceptedRejectedAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Duration type:</strong>
                      <h6>{currentItem.JobRequests?.duration || ""}</h6>
                    </div>
                  </div>
                  {currentItem?.allowance?.length > 0 &&
                    currentItem?.allowance?.map((item, i) => {
                      return (
                        <>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 w-full group">
                              <strong>Allowance {i + 1}:</strong>
                              <h6>${item?.allowanceChild || ""}</h6>
                            </div>
                          </div>
                        </>
                      );
                    })}
                  {/* <div className='sm:py-4 sm:px-2 py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <strong>Allowance 2:</strong>
                      <h6>{currentItem.allowanceTwo || ''}</h6>
                    </div>
                  </div>
                  <div className='sm:py-4 sm:px-2 py-8 px-7'>
                    <div className='relative z-0 w-full group'>
                      <strong>Deduction 1:</strong>
                      <h6>{currentItem.deductionOne || ''}</h6>
                    </div>
                  </div> */}
                  {currentItem?.deduction?.length > 0 &&
                    currentItem?.deduction?.map((item, i) => {
                      return (
                        <>
                          <div className="sm:py-4 sm:px-2 py-8 px-7">
                            <div className="relative z-0 w-full group">
                              <strong>Deduction {i + 1}:</strong>
                              <h6>${item?.deductionChild || ""}</h6>
                            </div>
                          </div>
                        </>
                      );
                    })}

                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Total Allowance:</strong>
                      <h6>${currentItem?.totalAllowance || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Total Deduction:</strong>
                      <h6>${currentItem?.totalDeduction || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 w-full group">
                      <strong>Net Salary:</strong>
                      <h6>${currentItem?.totalAllowance && currentItem?.totalDeduction ? <>{currentItem?.totalAllowance - currentItem?.totalDeduction}</> : 0}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => handleView()}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default SalaryView;
